import React from "react"
import styled from "styled-components"

/**
 * Parking section card: white surface, outline border, rounded, with an
 * optional uppercase header (title + subtitle) and a padded body.
 *
 * Master-fonts (grotesk = Avenir), no glass/backdrop-filter, no icons.
 * Mirrors the mockup Card from the parking redesign minus the bits that need
 * self-hosted fonts.
 *
 *   <Card title="Contact Information" subtitle="…">
 *     <CardSection>…</CardSection>
 *   </Card>
 */
const Shell = styled.section`
  background: ${(p) => p.theme.parking.colors.surfaceLowest};
  border: 1px solid ${(p) => p.theme.parking.colors.outlineVariant};
  border-radius: ${(p) => p.theme.parking.radius.lg};
  box-shadow: 0 1px 3px rgba(35, 41, 48, 0.06);
  overflow: hidden;
  width: 100%;
  box-sizing: border-box;
`

const Head = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 14px 18px;
  border-bottom: 1px solid ${(p) => p.theme.parking.colors.outlineVariant};
`

const HeadText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
`

const Title = styled.h2`
  margin: 0;
  font-family: ${(p) => p.theme.parking.fonts.grotesk};
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: ${(p) => p.theme.parking.colors.onSurface};
`

const Subtitle = styled.div`
  font-family: ${(p) => p.theme.parking.fonts.grotesk};
  font-size: 0.8rem;
  font-weight: 500;
  color: ${(p) => p.theme.parking.colors.onSurfaceVariant};
`

const Action = styled.div`
  margin-left: auto;
  flex-shrink: 0;
`

const Card = ({ title, subtitle, action, children }) => (
  <Shell>
    {title || action ? (
      <Head>
        <HeadText>
          {title ? <Title>{title}</Title> : null}
          {subtitle ? <Subtitle>{subtitle}</Subtitle> : null}
        </HeadText>
        {action ? <Action>{action}</Action> : null}
      </Head>
    ) : null}
    {children}
  </Shell>
)

const CardSection = styled.div`
  padding: 18px;
`

export default Card
export { CardSection }
